import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './i18n'; // Importer i18n
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
